/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Return_Total_InvInputs */

const vi_confirm_return_total_inv = /** @type {(inputs: Confirm_Return_Total_InvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng nhập lại SP:`)
};

/**

* @param {Confirm_Return_Total_InvInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const confirm_return_total_inv = /** @type {((inputs?: Confirm_Return_Total_InvInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Return_Total_InvInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_confirm_return_total_inv(inputs)
});